export enum ContributionPeriod {
  Monthly = 'monthly',
  Annually = 'annually',
}
